import service from 'axios'
import { getToken, clearStore } from '@/util/store';
import LoginThirdPart from "@/login/LoginThirdPart";
import Sign from '@/util/sign'
import store from '../store'
import { Message } from 'element-ui'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css'// progress bar style
// import router from '@/router/router';
import ObjUtil from '@/util/obj';
import { get } from "lodash"
import auth from "./auth"
import { Loading } from 'element-ui'
//默认请求响应超时时间
service.defaults.timeout = 1000 * 60;
//跨域请求，允许保存cookie
service.defaults.withCredentials = true;


// NProgress Configuration
NProgress.configure({ showSpinner: false })
let cfg, msg;
msg = '服务器君开小差了，请稍后再试';

let loadingInstance = null
let loadingInstanceList = []
//HTTPrequest拦截
service.interceptors.request.use(config => {
  if (config.url.indexOf('uploadAnnex') != -1 || config.url.indexOf('uploadZip') != -1 || config.url.indexOf('uploadFingerInfo') != -1) {
    loadingInstanceList.push(config.url)
    loadingInstance = Loading.service({
      lock: true,
      text: '上传中...',
      background: 'rgba(0, 0, 0, 0.7)',
    })
  }
  //NProgress.start(); // start progress bar
  let sign = new Sign();
  if (getToken() || auth.getToken()) {
    config['headers']['Authorization'] = getToken() || auth.getToken(); // 让每个请求携带token-- ['X-Token']为自定义key 请根据实际情况自行修改
  }
  let privateKey = sign.getPrivateKey();
  let timestamp = new Date().getTime();
  if (config.method == 'post') {
    let signParams = {
      ...config.data,
      _privateKey: privateKey,
      _timestamp: timestamp
    }
    config.headers['_timestamp'] = timestamp;
    config.headers['_signature'] = sign.sha1Obj(signParams);
  }
  return config;
}, error => {
  console.log('err' + error)// for debug
  return Promise.reject(error)
})
//HTTPresponse拦截
service.interceptors.response.use(data => {
  if (loadingInstanceList.includes(data.config.url)) {
    loadingInstanceList.splice(loadingInstanceList.indexOf(data.config.url), 1)
    if (loadingInstanceList.length === 0) {
      loadingInstance.close()
      loadingInstance = null
    }
  }
  NProgress.done();
  //判断类型为excel或pdf(excel文件会下载,pdf则是打开)
  if (data.headers['content-type'].indexOf('application/vnd.ms-excel') != -1 || data.headers['content-type'].indexOf('application/pdf') != -1 || data.headers['content-type'].indexOf('application/octet-stream') != -1) {
    return data.data;
  }
  if (get(data, "data.code") === 401) {
    Message({ showClose: true, message: data.data.msg, type: 'warning' });
    clearStore({})
    location.href = LoginThirdPart.getStraightThirdPartLoginUrl();
    return Promise.reject(data.data);
  }
  // debugger;
  if (get(data, "data.code") != '1' && get(data, "data.code") != '200') {
    Message({ showClose: true, message: data.data.msg, type: 'warning' });
    return Promise.reject(data.data);
  }
  return data.data;
}, error => {
  // 上传失败关闭遮罩层
  if (loadingInstanceList.includes(error.config.url)) {
    loadingInstanceList.splice(loadingInstanceList.indexOf(error.config.url), 1)
    if (loadingInstanceList.length === 0 && loadingInstance) {
      loadingInstance.close()
      loadingInstance = null
    }
  }
  console.log("request-error", error)
  NProgress.done();
  if (get(error, "response.status") === 500) {
    if (get(error, "response.data.code") === 603
      || get(error, "response.data.code") === 700) {
      Message({ showClose: true, message: get(error, "response.data.msg"), type: 'error' });
      store.dispatch("clearToken");
      store.dispatch("clearLock");
      store.dispatch("clearTag");
      let href = window.location.href;
      href = href.replace(/[&]token=[^&]+/, "")
      let request = service.create()
      // request.post("/ibs/loginNew",{appId: process.env.SSO_APP_ID,redirectUrl: href}).then(res=>{
      //   clearStore({type: "session"})
      //   if(res.data.data!==location.href){
      //       location.assign(res.data.data)
      //   }
      // })
      return Promise.reject(get(error, "response.data.msg"));
    } else {
      if (!get(error, "response.data.msg")) {
        Message({ showClose: true, message: get(error, "response.data.msg"), type: 'error' });
        return Promise.reject(get(error, "response.data.msg"));
      }
      Message({ showClose: true, message: get(error, "response.data.msg"), type: 'error' });
      return Promise.reject(get(error, "response.data.msg"));
    }
  } else {
    // Message({showClose: true, message: msg, type: 'error'});
    return Promise.reject(msg);
  }
})


export const http = {
  /**
   *
   * 自定义get请求
   *
   */
  get: function (url, params, config) {
    return service.get(url, { params: params }, config);
  },
  /**
   *
   * 自定义post请求
   *
   */
  post: function (url, params, config) {
    return service.post(url, params, config);
  },

  /**
   *
   * 自定义文件上传方法
   *
   */
  upload: function (url, params, config) {

    if (!config) {
      config = service.defaults.headers;
    }
    let configTmp = Object.assign({}, config);
    configTmp['timeout'] = 1000 * 60 * 5;
    configTmp['Content-Type'] = 'multipart/form-data';
    configTmp['Authorization'] = getToken();

    let formData = new FormData(); //创建form对象

    for (let field in params) {
      if (params[field]) {
        formData.append(field, params[field]);
      }
    }
    return service.post(url, formData, configTmp);
  },

  /**
   *
   * 自定义文件上传方法
   *
   */
  multiUpload: function (url, params, config) {
    if (!config) {
      config = service.defaults.headers;
    }
    let configTmp = Object.assign({}, config);
    configTmp['timeout'] = 1000 * 60 * 5;
    configTmp['Content-Type'] = 'multipart/form-data';
    configTmp['Authorization'] = getToken();

    let formData = new FormData(); //创建form对象
    for (let field in params) {
      // 如果参数是数组
      if (ObjUtil.isArray(params[field])) {
        params[field].forEach(function (item) {
          formData.append(field, item);
        })
      } else if (params[field]) {
        formData.append(field, params[field]);
      }
    }

    return service.post(url, formData, configTmp);
  },

  /**
   *
   * 自定义文件下载方法
   *
   */
  download: function (url, params, config) {
    var paramUrl = "?";
    for (let field in params) {
      if (params[field]) {
        paramUrl = paramUrl + field + "=" + params[field] + "&";
      }
    }
    paramUrl = paramUrl.substring(0, paramUrl.length - 1);
    window.location.href = url + paramUrl;
  },
  /**
   *
   * 自定义文件下载方法二
   *
   */
  download2: function (url, params, config) {

    if (!params.fileName) {
      console.error("下载时，文件名不能为空");
    }
    var fileName = params.fileName;
    axios({
      method: 'post',
      url: url,
      data: params,
      responseType: 'blob'
    }).then(response => {

      if (!response) {
        return;
      }
      let url = window.URL.createObjectURL(new Blob([response]));
      let link = document.createElement('a');
      link.style.display = 'none';
      link.href = url;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
    }).catch((error) => {
      console.log(error);
    })
  },
/**
   *
   * 自定义文件下载方法三
   *
   */
  download3: function (url, params, config) {

    if (!params.fileName) {
      console.error("导出时，文件名不能为空");
    }
    var fileName = params.fileName;
    service({
      method: 'post',
      url: url,
      data: params,
      responseType: 'blob'
    }).then(response => {

      if (!response) {
        return;
      }
      let url = window.URL.createObjectURL(new Blob([response]));
      let link = document.createElement('a');
      link.style.display = 'none';
      link.href = url;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
    }).catch((error) => {
      console.log('download error:', error);
      if (error instanceof Blob) {
        var reader = new FileReader();
        reader.onload = function(e) {
          try {
            var data = JSON.parse(e.target.result);
            Message({ showClose: true, message: data.msg, type: 'error' });
          } catch (e) {
            Message({ showClose: true, message: '导出失败', type: 'error' });
          }
        };
        reader.readAsText(error);
      }
    })
  },
  /**
   *
   * 自定义文件预览方法
   *
   */
  preview: function (url, params, config) {
    let paramUrl = "?";
    for (let field in params) {
      if (params[field]) {
        paramUrl = paramUrl + field + "=" + params[field] + "&";
      }
    }
    paramUrl = paramUrl.substring(0, paramUrl.length - 1);
    window.open(url + paramUrl);
  },


  lookPdf: function (url, params, config) {
    axios({
      method: 'post',
      url: url,
      data: params,
      responseType: 'blob',
    }).then(response => {
      // 使用blob解析，然后设置访问类型
      const blob = new Blob([response], { type: 'application/pdf' })
      let pdfSrc = window.URL.createObjectURL(blob)
      window.open(pdfSrc)//新窗口跳转打开，借用浏览器去打印
    }).catch((error) => {
      console.log(error, `error-----`)
    })
  },

}
export default http;
